export default __webpack_public_path__ + "static/media/empty.c08a4850.png";